<template>
  <v-app id="inspire">
    <notifications group="notif" position="bottom center" width="40%">
      <template slot="body" slot-scope="props">
        <v-container fluid class="pa-0 ma-0">
          <v-alert
            dense
            dismissible
            border="left"
            elevation="2"
            :type="props.item.type"
          >
            {{ props.item.text }}
          </v-alert>
        </v-container>
      </template>
    </notifications>
    <v-navigation-drawer
      v-if="isLoggedIn && showNavDrawer"
      app
      clipped
      v-model="showNavDrawer" 
      style="z-index: 6; top: 64px"
    >
      <v-list dense>
        <v-list-item to="/cards" link >
          <v-list-item-action>
            <v-icon>mdi-card-text</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("Cards") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="$store.getters.CAN_MANAGE_CARDS"
          to="/archiveCards"
          link
        >
          <v-list-item-action>
            <v-icon>mdi-card-text</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("ArchiveCards") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="$store.getters.CAN_SEE_DEVICES_MONITORING"
          to="/devicemonitoring"
          link
        >
          <v-list-item-action>
            <v-icon>mdi-card-text</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("DeviceMonitoring") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="$store.getters.CAN_SEE_KIOSKS" to="/kiosks" link>
          <v-list-item-action>
            <v-icon>mdi-card-text</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("Kiosks") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$store.getters.CAN_SEE_LOGS && $store.getters.DISPLAY_LOGS"
          to="/eventLog"
          link
        >
          <v-list-item-action>
            <v-icon>mdi-clipboard-text</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("EventLog") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          v-if="administrationLinksVisible.length"
          prepend-icon="mdi-account-circle"
          value="true"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ $t("Administration") }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(link, i) in administrationLinksVisible"
            :key="i"
            :to="link.to"
          >
            <v-list-item-content>
              <v-list-item-title>{{ link.title }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <AppBar 
      :showPasswordForm.sync="showPasswordForm" 
      :showNavDrawer="showNavDrawer" 
      @update:showNavDrawer="showNavDrawer = $event" 
    />

    <v-main>
      <v-container fluid style="padding-top: 0; padding-bottom: 0">
        <v-row align="start" justify="center">
          <router-view :key="$route.fullPath" />
        </v-row>
        <PasswordForm v-if="showPasswordForm && $store.getters.CAN_MANAGE_ROLES" @close="showPasswordForm = false" />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import PasswordForm from './components/Forms/PasswordForm.vue';
import AppBar from './components/AppBarComponents/AppBar';
import { setTranslations } from '@/plugins/i18n';

export default {
  components: {
    AppBar, PasswordForm
  },
  props: {
    source: String,
  },
  data: () => ({
    showPasswordForm: false,
    showNavDrawer: true,
  }),
  computed: {
    ...mapGetters(['isLoggedIn']),
    administrationLinksVisible() {
      return this.administrationLinks.filter((link) => link.visible);
    },
    administrationLinks() {
      return [
        {
          to: '/users',
          visible: this.$store.getters.CAN_SEE_USERS,
          title: this.$t('Users'),
          icon: 'mdi-account-multiple',
        },
        {
          to: '/roles',
          visible: this.$store.getters.CAN_MANAGE_ROLES,
          title: this.$t('Roles'),
          icon: 'mdi-account-multiple',
        },
        {
          to: '/banks',
          visible: this.$store.getters.CAN_SEE_BANKS,
          title: this.$t('Banks'),
          icon: 'mdi-bank',
        },
        {
          to: '/branches',
          visible: this.$store.getters.CAN_SEE_BRANCHES,
          title: this.$t('Branches'),
          icon: 'mdi-source-branch',
        },
        {
          to: '/devicesandproducts',
          visible: this.$store.getters.CAN_SEE_DEVICES,
          title: this.$t('DevicesAndProducts'),
          icon: 'mdi-cash-register',
        },
        {
          to: '/products',
          visible: this.$store.getters.CAN_SEE_PRODUCTS,
          title: this.$t('Products'),
          icon: 'mdi-alpha-p-circle-outline',
        },
      ];
    },
  },
  created: function() {
    if (this.$store.getters.isLoggedIn && !this.$store.state.userRights.length) {
      if (this.token) {
        this.$store.dispatch('getUserData', { vm: this }).catch(() => {
          this.$router.push({ path: '/login' });
        });
      }}
  },
  async mounted() {
    await this.getLoadingParams();
    this.$vuetify.theme.dark = this.$localStorageObj.getDarkValue();
    await this.loadDefaultTranslations();

  },
  methods: {
    async loadDefaultTranslations() {
      let lang = this.$localStorageObj.getLangByUser('');
      if (lang == undefined || lang == null) lang = 'en';
      try {
        await setTranslations(lang);
      } catch {
        console.error('error loadDefaultTranslations');
      }
    },
    async getLoadingParams() {
      try {
        // TODO вот тут надо попросить, чтобы возвращался из настроек 
        // loadingParams  bank_icon, которые мы 
        // сохраняем в разделе настроек администратора 
        const response = await this.$axios.loadingParams.get();
        // пример для Ostcard
        response.data.bank_Icon = 'favicon.ico';

        // пример для Tatvir
        // response.data.bank_Icon = 'https://static.tildacdn.pro/tild6536-3033-4630-a338-353834663631/3.png';

        this.$store.commit('setLoadingParams', response.data);

        if (response.data.emb_Url) {
          this.$axios.setEmbBaseUrl(response.data.emb_Url);
        }

        // меняем иконку и title сайта
        document.title = this.$store.getters.BANK_TITLE; 
        const favicon = document.querySelector('link[rel="icon"]');
        favicon.href = this.$store.getters.BANK_ICON;
      } catch (error) {
        console.error(error);
      }
    },
  }
};
</script>

<style>
/* Высота строк таблицы (под 3 строки текста). Применяется ко всем v-data-table. */
.v-data-table .v-data-table__wrapper table tbody tr {
  min-height: 60px !important;
  height: auto !important;
}
.v-data-table .v-data-table__wrapper table tbody tr td {
  min-height: 60px !important;
  height: auto !important;
  vertical-align: middle !important;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
  white-space: normal !important;
}
</style>
